import { Children, cloneElement, FC, isValidElement, useRef } from "react";
import { View } from "react-native";
import { useAppDispatch } from "src/redux";
import { closeTooltip, openTooltip, toggleTooltip } from "src/redux/modals/actions";

export type tPdTooltipMeasureValues = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export type tPdTooltipDirection = "top-left" | "bottom-right";

export type tPdTooltip = {
  direction?: tPdTooltipDirection;
  render: () => React.ReactNode;
};

export const PdTooltip: FC<tPdTooltip> = ({ children, direction = "bottom-right", render }) => {
  const isOpenRef = useRef(false);
  const referenceRef = useRef<View>();
  const dispatch = useAppDispatch();

  const onTouchStart = () => {
    isOpenRef.current = true;
  };

  const onMouseEnter = () => {
    if (!isOpenRef.current) {
      referenceRef.current?.measureInWindow((x, y, width, height) => {
        dispatch(openTooltip({ direction, render, referenceMeasureValues: { x, y, width, height } }));
      });
    }
  };

  const onMouseLeave = () => {
    isOpenRef.current = false;
    dispatch(closeTooltip());
  };

  const onClick = () => {
    referenceRef.current?.measureInWindow((x, y, width, height) => {
      dispatch(toggleTooltip({ direction, render, referenceMeasureValues: { x, y, width, height } }));
    });
  };

  const child = Children.only(children);

  if (!isValidElement(child)) {
    return null;
  }

  return cloneElement(child, {
    ...child.props,
    ref: referenceRef,
    onTouchStart,
    onMouseEnter,
    onMouseLeave,
    onClick,
  });
};
